import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    count:'111111111'
  },
  getters: {
  },
  mutations: {
    setData(state, payload) {
      state.data = payload;
    }
  },
  actions: {
  },
  modules: {
  }
})
